import React, { useState, useEffect, useCallback } from "react";
import {
  Box,
  Typography,
  Button,
  FormControl,
  TextareaAutosize,
  IconButton,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { searchfetchQueries } from "../../../../../services/BackendServices";

// Tab 6: Others
const OthersTab = ({
  internalComments,
  setInternalComments,
  termsAndConditions,
  handleOpenTermsModal,
  handleDeleteTermsFile,
  otherFiles,
  handleOpenFilesModal,
  handleDeleteOtherFile,
  paymentConditionFiles,
  handleOpenPaymentConditionModal,
  handleDeletePaymentConditionFile,
  errors,
  isViewMode,
  fileUrl,
  requiredDocumentsMaster,
  setRequiredDocumentsMaster,
  selectedRequiredDocuments,
  setSelectedRequiredDocuments,
  documentCategoryMaster,
  setDocumentCategoryMaster,
  setLoading,
  activeUser,
  setDocumentVaultUserFiles,
  documentVaultUserFiles,
}) => {
  const loadUserDocumentVault = useCallback(async () => {
    setLoading(true);
    try {
      const [allDocs] = await Promise.all([
        searchfetchQueries({
          target: "listUserDocument",
          userOrder: "DocumentId",
          rowStart: 0,
          pageSize: 1000,
          CreatedBy: activeUser,
        }),
      ]);
      setDocumentVaultUserFiles(allDocs);
    } catch (error) {
      console.error("Error loading user document vault files: ", error);
      setDocumentVaultUserFiles([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading, activeUser]);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    let updatedDocs;
    if (checked) {
      updatedDocs = [...selectedRequiredDocuments, name];
    } else {
      updatedDocs = selectedRequiredDocuments.filter((doc) => doc !== name);
    }

    console.log("Updated docs before state:", updatedDocs);

    // now set state
    setSelectedRequiredDocuments(updatedDocs);
    console.log(
      "selectedRequiredDocumentsInChild@@@",
      selectedRequiredDocuments
    );
  };

  useEffect(() => {
    if (activeUser && !isViewMode) {
      loadUserDocumentVault();
    }
  }, [activeUser, loadUserDocumentVault]);

  return (
    <div className="row g-3">
      <div className="col-md-12">
        <Typography variant="body2">Internal Comments</Typography>
        <TextareaAutosize
          value={internalComments || ""}
          onChange={(e) => setInternalComments(e.target.value)}
          style={{
            backgroundColor: "white",
            width: "100%",
            minHeight: "56px",
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
            fontFamily: "inherit",
            fontSize: "14px",
            resize: "vertical",
          }}
          minRows={2}
          placeholder="Enter internal comments (not visible to suppliers)"
          disabled={isViewMode}
        />
      </div>
      <div className="col-md-12">
        <FormControl fullWidth>
          <Typography variant="body2">Required Documents</Typography>
          <div className="d-flex flex-wrap gap-3">
            {requiredDocumentsMaster.map((doc) => (
              <div className="col-md-2">
                <FormControlLabel
                  key={doc.Value}
                  control={
                    <Checkbox
                      name={doc.Value}
                      checked={(selectedRequiredDocuments || []).includes(
                        doc.Value
                      )}
                      onChange={handleCheckboxChange}
                      size="small"
                      sx={{
                        color: "#de6b14",
                        "&.Mui-checked": {
                          color: "#de6b14",
                        },
                      }}
                    />
                  }
                  label={doc.Value}
                  disabled={isViewMode}
                />
              </div>
            ))}
          </div>
        </FormControl>
      </div>
      <div className="col-md-6">
        <Typography variant="body2">Terms and Conditions</Typography>
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "8px",
            minHeight: "120px",
            backgroundColor: "white",
          }}
        >
          {Array.isArray(termsAndConditions) &&
          termsAndConditions.length > 0 ? (
            termsAndConditions.map((file, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "4px 8px",
                  marginBottom: "4px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "4px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <PictureAsPdfIcon sx={{ marginRight: 1, color: "#d32f2f" }} />
                  <Typography variant="body2">
                    <a
                      href={fileUrl + file?.name}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {file?.name || "Unnamed File"}
                    </a>
                  </Typography>
                </Box>
                {!isViewMode && (
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteTermsFile(index)}
                    sx={{ color: "#d32f2f" }}
                  >
                    <RemoveIcon />
                  </IconButton>
                )}
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              No terms and conditions files uploaded
            </Typography>
          )}
          {!isViewMode && (
            <Button
              startIcon={<AddIcon />}
              onClick={handleOpenTermsModal}
              sx={{ marginTop: 1 }}
            >
              Add Terms & Conditions
            </Button>
          )}
        </Box>
      </div>

      <div className="col-md-6">
        <Typography variant="body2">Other Documents</Typography>
        <Box
          sx={{
            border: "1px solid #ccc",
            borderRadius: "4px",
            padding: "8px",
            minHeight: "120px",
            backgroundColor: "white",
          }}
        >
          {Array.isArray(otherFiles) && otherFiles.length > 0 ? (
            otherFiles.map((file, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "4px 8px",
                  marginBottom: "4px",
                  backgroundColor: "#f5f5f5",
                  borderRadius: "4px",
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <PictureAsPdfIcon sx={{ marginRight: 1, color: "#d32f2f" }} />
                  <Typography variant="body2">
                    <a
                      href={fileUrl + file?.name}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ textDecoration: "none", color: "inherit" }}
                    >
                      {file?.name || "Unnamed File"}
                    </a>
                  </Typography>
                </Box>
                {!isViewMode && (
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteOtherFile(index)}
                    sx={{ color: "#d32f2f" }}
                  >
                    <RemoveIcon />
                  </IconButton>
                )}
              </Box>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary">
              No other documents uploaded
            </Typography>
          )}
          {!isViewMode && (
            <Button
              startIcon={<AddIcon />}
              onClick={handleOpenFilesModal}
              sx={{ marginTop: 1 }}
            >
              Add Other Documents
            </Button>
          )}
        </Box>
      </div>
    </div>
  );
};
export default OthersTab;
